export default {"src":"/_next/static/media/icon-db-left.4b798624.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};